<script>
    import _            from 'lodash'
    import { navigate } from "svelte-routing"
    import { fade }     from 'svelte/transition'
    import Modal        from '../../shared/Modal.svelte'
    import * as pages   from '../../shared/pages.js'
    import * as api     from '../../shared/api.js'
    import { user }     from '../../shared/stores.js'
    import Delete       from './Delete.svelte'
    import FileUpload   from '../../shared/FileUpload.svelte'

    export let _company
    export let _domain
    export let _inquiry
    export let _source

    let loading     = true
    let working     = false
    let submitted   = false
    let loadError   = false
    let submitError = false
    let place       = null
    let inquiry     = null
    let keys        = []
    let buffer      = [] //all entries
    let entry       = [] // an array of {field, value}
    let showBuffer  = false
    let pin         = null

    const anonymous = !$user.loggedIn 
    const qs        = new URLSearchParams(window.location.search)
    const token     = qs.get('token') 
    const lnk       = `/empresa/${_company}/pedidos/${_domain}/pedido/${_inquiry}`

    pages.onMount(`/inquiry/${_inquiry}/source/${_source}?dm=${qs.get('dm')}`).then(it => {
        loading = false
        place   = it.place
        inquiry = it.inquiry
        keys    = it.keys
        entry   = newEntry()
    }).catch(err => {
        loadError = err
        loading = false
    })

    function newEntry() {
        const inscope = filterFields(inquiry, place)
        return inscope.map(field => {
            const value = valueGiven(field)
            return { field: field, value }
        })
    }

    function assignValues() {
        const inscope = filterFields(inquiry, place)
        return inscope.map(field => {
            const value = valueGiven(field)
            return { place: place.id, field: field.id, value }
        })
    }

    function appendEntry() {
        buffer = [...buffer, entry]
        entry = newEntry()
    }

    function removeEntry(index) {
        return e => {
            buffer = buffer.filter( (entry, idx) => idx !== index)
            if(buffer.length === 0) 
                showBuffer = false
        }
    }

    function submit() {
        working = true

        // const values = buffer.map(entry => entry.map(item => {
        //     return { place: item.field.place, field: item.field.id, value: item.value }
        // }))

        const values = buffer.map(entry => {
            const result = {}
            entry.map(item => result["f"+item.field.id] = item.value)
            return result
        })

        const data = {
            id    : _inquiry,
            place : _source,
            data  : values, 
            pin   : pin, 
            token : token
        }

        api .post(`/inquiry/submit?dm=${qs.get('dm')}`, data)
            .then(api.toJsonIf200)
            .then(it => {
                working   = false
                submitted = true
            })
            .catch(err => {
                submitError = err
                working = false
                setTimeout(() => submitError = false, 5000)
            })
    }

    function tooltipGiven(field) {
        return field.definition
    }

    function valueGiven(field) {
        //console.log(field)
        const found = keys.find(i => i.field.definition === field.definition)
        return found ? found.value : null
    }

    function extractValue(e) {
        return e.target.value
    }

    function extractDetail(e) {
        return e.detail.value
    }

    function assignValueToItem(item, fn) {
        return e => {
            entry = entry.map(it => {
                if(it.field.id == item.field.id) {
                    const value = fn(e)
                    return { ...it, value }
                } else {
                    return it
                }
            })
        }
    }

    function filterFields(inquiry, place) {
        if(inquiry) {
            const scope = inquiry.scope
            return place.fields.filter(f => f.scopes.find(s => s === scope))
        } else {
            return []
        }
    }

    function validateInput(item) {
        return _.trim(item.value)
    }

    function verifyEntry(entry) {
        return entry.every(it => {
            return _.trim(it.value)
        })
    }

    $: clazz  = loadError ? 'thumbs down outline icon' : 'notched circle loading icon'
    $: fields = filterFields(inquiry, place)
    $: appendDisabled = !verifyEntry(entry)
    $: disabled = working || (inquiry && inquiry.scope === 'DDR') || buffer.length === 0 || (anonymous && !pin)
</script>
<style>
    .keys, .fields {
        margin: 20px 0;
    }

    .key, .fields .input {
        margin: 12px 0;
    }

    .actions {
        margin-top: 2em;
    }

    .flex {
        display: flex;
    }

    .entry > div {
        margin-right: 1em;
        flex: 1;
    }

    .ui.icon.input {
        margin: 0;
    }

    .summary {
        display: flex;
        justify-content: flex-end;
    }

    button.count {
        background: transparent;
    }

    .values {
        padding: 1em 0;
    }

    .entry {
        display        : flex;
        flex-direction : row;
        align-items    : center;
        padding        : 1em 0;
    }

</style>
<Modal display={true}>
    <div slot="content">
        <div class:loading class="ui basic segment">
            {#if place}
                {#if submitted}
                    <div class="ui icon green message">
                        <i class="thumbs up outline icon"></i>
                        <div class="content">
                            <div class="header">
                                {place.name}
                            </div>
                            <p>Informações enviadas com sucesso!</p>
                            {#if !anonymous}
                                <button class="ui basic black button"
                                        on:click={() => navigate(lnk)}>
                                    Ver pedido
                                </button>
                            {/if}
                        </div>
                    </div>                
                {:else}
                    <div class="ui message">
                        <div class="header"><h2>{place.name}</h2></div>
                        <div class="header"><h6>{_inquiry}</h6></div>
                        <div class="keys">
                            {#each place.fields.filter(i => i.key) as field}
                                <div class="key">
                                    <span class="ui black label">
                                       { field.name || field.definition }: { valueGiven(field) }
                                    </span>
                                </div>
                            {/each}
                        </div>
                        <div class="fields">
                            <form class="ui form">
                                {#each entry as item}
                                    {#if inquiry.scope === 'DDR'}
                                        <Delete {inquiry} field={item.field} />
                                    {:else}
                                        <div class="field" class:disabled={working} class:required={item.field.required}>
                                            <label>{item.field.name || item.field.definition}</label>
                                            <div class="ui right icon input">
                                                {#if !item.field.kind || item.field.kind === "TEXT"}
                                                    <input  type="text" 
                                                            placeholder=""
                                                            value={item.value}
                                                            on:change={assignValueToItem(item, extractValue)}/>
                                                    <i class="check icon" class:green={validateInput(item)}></i>
                                                {:else}
                                                    <FileUpload on:change={assignValueToItem(item, extractDetail)}/>
                                                {/if}
                                            </div>
                                        </div>
                                    {/if}
                                {/each}
                            </form>
                        </div>
                        <div class="actions">
                            <div class="ui basic segment">
                                <button class="ui icon button"
                                        class:loading={working}
                                        class:disabled={working || inquiry.scope === 'DDR' || appendDisabled} 
                                        on:click={appendEntry}>
                                    <i class="plus icon"></i>
                                </button>
                                <button class="ui count button" on:click={e => showBuffer = !showBuffer }>
                                    {buffer.length} ítens para envio
                                </button>
                                <!-- <div style="flex: 1"></div> -->
                            </div>
                        </div>
                        <div class="values">
                            {#if showBuffer}
                                {#each buffer as entry, index (index)}
                                    <div class="entry">
                                        <div class="ui list">
                                            {#each entry as item}
                                                <div class="item">
                                                    <div class="header">{item.field.name || item.field.definition}</div>
                                                    {item.value}
                                                </div>
                                            {/each}
                                        </div>                            
                                        <button class="ui icon button" on:click={removeEntry(index)}>
                                            <i class="trash alternate outline icon"></i>
                                        </button>                                
                                    </div>
                                {/each}
                            {/if}
                        </div>
                        {#if buffer.length > 0}
                            <div class="ui basic segment form flex" transition:fade>
                                <div style="flex: 1"></div>
                                <div class="inline fields">
                                    {#if anonymous}
                                        <div class="field" class:disabled={working}>
                                            <label>PIN</label>
                                            <input type="text" placeholder="0000" bind:value={pin}>
                                        </div>
                                    {/if}
                                    <button class="ui blue button"
                                            class:loading={working}
                                            class:disabled 
                                            on:click={submit}>
                                        Enviar
                                    </button>
                                </div>
                            </div>
                            {#if submitError}
                                <div class="flex" transition:fade>
                                    <div style="flex: 1"></div>
                                    <div class="ui red label">Erro ao enviar dados. Verifique seu PIN</div>
                                </div>
                            {/if}
                        {:else}
                            <div class="ui basic segment flex" transition:fade>
                                <div style="align-self: center; flex: 1">Dados não encontratos para este titular</div>
                                <button class="ui black button" on:click={submit}>
                                    Resposta Vazia
                                </button>
                            </div>                    
                        {/if}
                    </div>
                    {#if anonymous}
                        <div class="ui purple message">
                            Você está respondendo ao pedido de forma anônima.
                            Caso você tenha um usuário na Dogma, faça o seu <a href={window.location + "&fa"}>login</a> antes de responder.
                        </div>
                    {/if}
                {/if}
            {:else}
                <div class:red={loadError} class="ui icon message">
                    <i class="{clazz}"></i>
                    <div class="content">
                        <div class="header">
                            {#if loadError}
                                Erro
                            {:else}
                                Carregando
                            {/if}
                        </div>
                        <p>Dados do pedido {_inquiry}</p>
                    </div>
                </div>
            {/if}
        </div>
    </div>
</Modal>
